import React, { forwardRef, useEffect, useImperativeHandle, useMemo, useRef, useState } from 'react'
import { useSetState } from 'ahooks'
import { Button, Checkbox, Input, Radio, Select, Spin, Tooltip, TreeSelect } from 'antd'
import { SGeneralForms, SLocalSelected } from 'shj-components'
import { getProductEnums, getSkuPageList, getUpdateNodes } from '@/services/product.ts'
import { getRoleList } from '@/services/homeService.ts'
import { useParams } from 'react-router-dom'
import { treeToOneArr } from '@/common/utils.ts'
import { replaceRule } from '@/utils/data.ts'
import RulesModal from '@/pages/baseProduct/components/RuleModal/RulesModal'
import DebounceSearchSelect from '@/pages/baseProduct/components/DebounceSearchSelect'
import { cloneDeep, debounce } from 'lodash-es'
import _ from 'lodash'
import { QuestionCircleOutlined } from '@ant-design/icons'

type IProps = {
  fn: () => void
  onClose: () => void
  record: Record<string, any>
  dataSource?: any[]
  readOnly?: boolean
  companyList: any[]
}

export const AddOrEditProduct = forwardRef((props: IProps, ref) => {
  const { id } = useParams()
  const { record = {}, dataSource = [], readOnly = false, companyList } = props
  const formRef = useRef()
  const [state, setState] = useSetState<any>({
    roleList: [],
    searchRoleValue: '',
    selectedRoleList: [], // 选中的过滤角色list
    filterRoleList: [], // 过滤角色list
    projectList: [],
    initValues: {},
    loading: false,
    productList: [],
    productShowName: '',
    updateNodesList: [], // 更新节点
  })
  const [ruleModal, setRuleModal] = useSetState({
    open: false,
    mode: 'modal',
    value: '',
  })
  const [optionList, setOptionList] = useState([{ id: '0', name: '通用' }, ...companyList])

  useEffect(() => {
    console.log(record, '-------初始化record数据')
    setRuleModal({ value: '' })
    if (record.id) {
      const shops = record?.shops || []
      const roles = record?.roles || []
      const rule = JSON.parse(record.budgetQuantityRule || null)?.rule || ''
      const parentId = record.parentId !== '0' ? record.parentId : ''
      const obj = {
        ...record,
        parentId,
      }
      console.log(obj)
      console.log(state.filterRoleList)
      onFormRef()?.setFieldsValue({ ...obj })
      setState({ initValues: { ...obj, shops, roles } })
      shopsControl(record.shops)

      setRuleModal({ value: rule })
    } else if (record.parentId) {
      onFormRef()?.setFieldsValue({ ...record })
    }

    // 添加更新节点
    if (record.updateNodesList?.length) {
      setState({
        updateNodesList: record.updateNodesList,
      })
    } else {
      getUpdateNodes().then((res: any) => {
        setState({
          updateNodesList:
            res?.map(item => {
              return {
                ...item,
                checked: record.updateNodes ? record.updateNodes?.includes(item.node) : false,
              }
            }) || [],
        })
      })
    }
  }, [record, state.filterRoleList])

  useEffect(() => {
    getRole()
    getProjectList()
  }, [])

  useEffect(() => {
    getProduct(state.searchValue)
  }, [state.searchValue])

  const getProduct = debounce(async (nameKey?) => {
    const data: any = await getSkuPageList({
      pageId: 1,
      pageSize: 10,
      data: {
        skuNameKey: '', //sku名称检索
        busType: 'prod', //必传-对应产品还是打包模版的sku，该处默认传-prod
      },
    })
    setState({ productList: data.list || [] })
  }, 500)
  const getProjectList = () => {
    if (id) {
      setState({ projectList: props.baseInfo?.treeNodes })
    } else {
      setState({ projectList: dataSource })
    }
  }

  const getRole = async () => {
    const data: any = await getRoleList({ data: { enabled: true } })
    setState({ filterRoleList: data || [] })
  }

  const onFormRef = () => {
    const { onFormRef } = formRef.current || {}
    return onFormRef?.()
  }
  const getOptions = async (): Promise<{ [key: string]: any }> => {
    setState({ loading: true })
    const roleList = await getProductEnums('com.shj.saas.plus.product.enums.RoleFilterTypeEnum')
    setState({
      roleList: roleList.map(item => ({ label: item.description, value: item.key })),
      loading: false,
    })
    return Promise.resolve({ ...props?.options })
  }

  const getShopArr = codeArr => {
    return optionList?.reduce((res, item) => {
      if (codeArr.includes(item.id)) res.push({ id: item.id, companyName: item.name })
      return res
    }, [])
  }
  const shopsControl = (value: any) => {
    let newOption: any = _.cloneDeep(optionList)
    if (value?.length) {
      if (value.includes('0')) {
        newOption = newOption.map((item: any) => {
          return {
            ...item,
            disabled: item.id !== '0',
          }
        })
      } else {
        newOption = newOption.map((item: any) => {
          return {
            ...item,
            disabled: item.id === '0',
          }
        })
      }
    } else {
      newOption = newOption.map((item: any) => {
        return {
          ...item,
          disabled: false,
        }
      })
    }
    setOptionList(newOption)
  }
  const onFinish = () => {
    return new Promise((resolve, reject) => {
      onFormRef()
        ?.validateFields()
        .then(values => {
          props.setLoading?.(true)
          console.log(state)
          const shopList = values.shops ? getShopArr(values.shops) : []
          // const showName = state.productList.find(item => item.id === values.busId)?.skuName
          const newValues = {
            ...values,
            id: values.id,
            parentId: values.parentId || '0',
            oldParentId: record?.parentId || '',
            busId: values.busId,
            dtlName: state.productShowName || state.initValues.dtlName,
            shopList: shopList,
            shops: values.shops,
            roleFilterValue: values.roleFilterValue,
            isCopy: values.isCopy,
            isShowOrder: values.isShowOrder,
            roleFilterType: values.roleFilterType,
            busType: 'PRD_PRODUCT',
            busTypeName: '产品',
            budgetQuantityRule: JSON.stringify({ rule: ruleModal.value }),
            updateNodesList: state?.updateNodesList,  // 更新节点
            updateNodes: state?.updateNodesList
              .filter(item => item.checked)
              ?.map(item => item.node),
          }
          resolve(newValues)
        })
    })
  }
  useImperativeHandle(ref, () => {
    return {
      onFinish,
    }
  }, [onFinish])
  const dealTree = (data, res = []) => {
    data.forEach(item => {
      if (item.busType === 'PRD_CATE' || item.busType === 'PRD_PROJECT') {
        res.push(item)
        if (item.children?.length) {
          item.children = dealTree(item.children)
        }
      }
    })
    return res
  }
  const tree = useMemo(() => {
    return dealTree(cloneDeep(dataSource))
  }, [dataSource])

   // 更新节点
   const onChangeTime = e => {
    const newList = state.updateNodesList
    console.log(e)
    console.log(newList)
    newList.forEach((item: any) => {
      if (e.target.value === 'BEFORE_START_WORK' && e.target.checked) {
        item.checked = true
      } else if (e.target.value === 'BEFORE_SIGN' && !e.target.checked) {
        item.checked = false
      } else if (item.node === e.target.value) {
        item.checked = e.target.checked
      }
    })
    setState({
      updateNodesList: [...newList],
    })
    onFormRef()?.setFieldsValue({
      updateNodesList: [...newList],
    })
  }
  return (
    <Spin spinning={state.loading}>
      <SGeneralForms
        ref={formRef}
        isHideGobackBtn={true}
        isDetail={readOnly}
        httpOptionsFn={getOptions}
        initialValues={
          !record.id
            ? {
                isSubtract: true,
                isCopy: true,
                isShowOrder: true,
                standardFlag: false,
                roleFilterType: 'NONE_FILTER',
              }
            : {}
        }
        layout="vertical"
        titleMode={props.readOnly ? '' : 'edit'}
        configs={[
          {
            title: '基础信息',
            formItem: [
              { name: 'id', hidden: true },
              {
                name: 'parentId',
                label: '所属项目',
                spanCol: 24,
                children: (
                  <TreeSelect
                    treeData={tree}
                    placeholder={'请选择所属项目'}
                    fieldNames={{ label: 'name', value: 'id' }}
                    treeTitleRender={node => node?.dtlName}
                  />
                ),
              },
              {
                name: 'busId',
                label: '产品SKU',
                required: !props.readOnly,
                rules: [{ required: true, message: '产品SKU不能为空' }],
                spanCol: 24,
                children: (
                  <DebounceSearchSelect
                    readOnly={props.readOnly}
                    fetchOptions={getSkuPageList}
                    label={'产品SKU'}
                    nameKey={'keyword'}
                    // disabled={props.record?.id}
                    fixedParams={{
                      prodTypes: ['PRODUCT_SINGLE', 'PRODUCT_GROUP', 'PRODUCT_BASIC_ITEM'],
                    }}
                    fieldNames={{ label: 'showName', value: 'id' }}
                    query={{ id: state.initValues.busId }}
                    onChange={(v, o) => {
                      setState({ productShowName: o?.skuName })
                    }}
                  />
                ),
              },
            ],
          },
          {
            title: '打包配置',
            titleMode: 'drawer',
            formItem: [
              {
                name: 'standardFlag',
                label: '是否标配',
                spanCol: 24,
                type: 'switch',
                comConfig: {
                  checkedChildren: '是',
                  unCheckedChildren: '否',
                },
              },
              {
                name: 'isSubtract',
                label: '是否可减项',
                spanCol: 24,
                type: 'switch',
                comConfig: {
                  checkedChildren: '是',
                  unCheckedChildren: '否',
                },
              },
              {
                name: 'isCopy',
                label: '是否可复制',
                spanCol: 24,
                type: 'switch',
                comConfig: {
                  checkedChildren: '是',
                  unCheckedChildren: '否',
                },
              },
              {
                label: '预算量',
                spanCol: 24,
                [props.readOnly ? 'name' : '']: 'budgetQuantityRule',
                [props.readOnly ? '' : 'children']: (
                  <div>
                    <Button onClick={() => setRuleModal({ open: true })}>编辑规则</Button>
                    {ruleModal?.value && (
                      <Input.TextArea
                        autoSize={{ minRows: 1, maxRows: 4 }}
                        disabled
                        style={{ marginTop: 6 }}
                        value={replaceRule(ruleModal.value)}
                      />
                    )}
                  </div>
                ),
              },
              {
                name: 'allowUpdateBudgetQuantity',
                label: '预算量是否可编辑',
                spanCol: 24,
                type: 'switch',
                comConfig: {
                  checkedChildren: '是',
                  unCheckedChildren: '否',
                },
              },
            ],
          },
          {
            title: '显示配置',
            titleMode: 'drawer',
            formItem: [
              {
                name: 'isShowOrder',
                label: '下单时是否显示',
                spanCol: 24,
                type: 'switch',
                comConfig: {
                  checkedChildren: '是',
                  unCheckedChildren: '否',
                },
              },
              {
                name: 'roleFilterType',
                label: '系统角色过滤',
                spanCol: 24,
                children: readOnly ? (
                  <div>
                    {state.roleList.find(item => item.value === record?.roleFilterType)?.label}
                  </div>
                ) : (
                  <Radio.Group options={state.roleList} />
                ),
              },
              {
                name: 'roleFilterValue',
                label: '过滤角色',
                spanCol: 24,
                required: true,
                rules: [{ required: true, message: '过滤角色不能为空' }],
                isDeps: true,
                deps: form => form.getFieldValue('roleFilterType') !== 'NONE_FILTER',
                children: readOnly ? (
                  <div>{state.initValues.roles?.map(item => item.name)?.join(', ')}</div>
                ) : (
                  <SLocalSelected
                    optionsData={state.filterRoleList}
                    placeholder={'输入搜索过滤角色'}
                    configData={{ label: 'name', value: 'id' }}
                    mode={'multiple'}
                    onChange={(_, o) => {
                      setState({
                        selectedRoleList: o.map(item => ({
                          id: item.value,
                          name: item.children,
                        })),
                      })
                    }}
                  />
                ),
              },
            ],
          },
          {
            title: '适用渠道',
            titleMode: 'drawer',
            formItem: [
              {
                name: 'shops',
                label: '适用门店',
                spanCol: 24,
                children: readOnly ? (
                  <div>{state.initValues.shops?.map(item => item.name)?.join(', ')}</div>
                ) : (
                  <Select
                    mode={'multiple'}
                    optionFilterProp={'name'}
                    placeholder={'请选择适用门店'}
                    fieldNames={{ label: 'name', value: 'id' }}
                    onChange={(value, option) => {
                      shopsControl(value)
                    }}
                    options={optionList}
                  />
                ),
              },
            ],
          },
          {
            title: '更新配置',
            formItem: [
              {
                name: 'updateNodes',
                label: (
                  <>
                    <Tooltip title="该项数据新增或编辑后，对订单商品哪些节点的报价生效。注意：默认所有新增报价均会生效。">
                      <span>
                        <QuestionCircleOutlined /> 更新节点
                      </span>
                    </Tooltip>
                  </>
                ),
                spanCol: 24,
                children: (
                  <>
                    {state.updateNodesList?.map((item, index) => {
                      return (
                        <Checkbox
                          key={index}
                          checked={item.checked}
                          value={item.node}
                          onChange={onChangeTime}
                        >
                          {item.name}
                        </Checkbox>
                      )
                    })}
                  </>
                ),
              },
            ],
          },
        ]}
      />
      {ruleModal.open && (
        <RulesModal
          modalProps={{ ...ruleModal }}
          onCancel={() => setRuleModal({ open: false })}
          type={'generalBudgetItem'}
          onOk={(value: string) => setRuleModal({ value })}
        />
      )}
    </Spin>
  )
})
